import axios from "axios";
import { getStore, removeStore } from "./storage";

import qs from "qs";

// 公用地址
let baseURL;
baseURL = "https://www.uobay.com/news";

const userInfoJsonString = getStore("user");
const userInfo = JSON.parse(userInfoJsonString);
const token = userInfo !== null && userInfo.token ? userInfo.token : "";
// 创建axios实例
const service = axios.create({
  baseURL,
  timeout: 50000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
});

// request 拦截器
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers.Authorization = token;
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error);
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code > 0) {
      removeStore("user");
      // window.location.href = window.location.href
    }
    /**
     * success为非true是抛错 可结合自己业务进行修改
     */
    return response.data;
  },
  error => {
    console.log(`err${error}`);
    return Promise.reject(error);
  }
);

/**
 * 发送ajax请求
 * @param    {String}  url     地址
 * @param    {String}  method  请求方式 get post put delete
 * @param    {Object}  data    参数对象
 * @param    {Object}  ctx 参数
 */
const callApi = (url, method, data, ctx) => {
  if (process.env.NODE_ENV === "development") {
    // 开发环境
    if (url.indexOf("?") > -1) {
      url += `&t=${Math.random()}`;
    } else {
      url += `?t=${Math.random()}`;
    }
  }
  return service(
    Object.assign(
      {},
      {
        url: `${url}`,
        method,
        params: method === "get" ? Object.assign({}, data) : {},
        data: method !== "get" ? qs.stringify(data) : {}
      },
      ctx
    )
  );
};
export const getApi = (url, data = {}, ctx = {}) =>
  callApi(url, "get", data, ctx);
export const postApi = (url, data = {}, ctx = {}) =>
  callApi(url, "post", data, ctx);
